import { render, staticRenderFns } from "./SatisfactionGuaranteedSection.vue?vue&type=template&id=15348ca7&scoped=true&functional=true&"
import script from "./SatisfactionGuaranteedSection.vue?vue&type=script&lang=js&"
export * from "./SatisfactionGuaranteedSection.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionGuaranteedSection.vue?vue&type=style&index=0&id=15348ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "15348ca7",
  null
  
)

export default component.exports